import React, { useState } from "react";
import { Camera } from "lucide-react";
import { useProjectContext } from "../../../hooks/useProjectContext";
import { usePhotos } from "../../../hooks/usePhotos";

import PhotoUploadForm from "../../modals/forms/PhotoForm/photoUploadForm";
import PhotoListForm from "../../modals/forms/PhotoForm/photolistForm";

const EMPTY_META = {
  caption: "",
  tags: "",
  description: "",
  inspection_id: "",
  ncr_id: "",
};

const PhotosView = () => {
  const { activeProject } = useProjectContext();
  const { photos, loading, uploading, error, upload, remove } = usePhotos();

  const [file, setFile] = useState(null);
  const [meta, setMeta] = useState(EMPTY_META);

  if (!activeProject) return null;

  const onMetaChange = (field, value) => {
    setMeta((p) => ({ ...p, [field]: value }));
  };

  const onUpload = async (e) => {
    e.preventDefault();
    if (!file) return;

    const fd = new FormData();
    fd.append("file", file);
    fd.append("caption", meta.caption || "");
    fd.append("description", meta.description || "");
    fd.append("tags", meta.tags || "");
    if (meta.inspection_id) fd.append("inspection_id", meta.inspection_id);
    if (meta.ncr_id) fd.append("ncr_id", meta.ncr_id);

    await upload(fd);

    setFile(null);
    setMeta(EMPTY_META);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Photos</h2>
          <p className="text-gray-600">Site photos and visual documentation</p>
        </div>
        <Camera className="w-8 h-8 text-pink-500" />
      </div>

      {/* Upload (reusable) */}
      <PhotoUploadForm
        value={meta}
        onChange={onMetaChange}
        file={file}
        onFileChange={setFile}
        onSubmit={onUpload}
        uploading={uploading}
      />

      {/* List (reusable) */}
      <PhotoListForm
        title="Photo List"
        photos={photos}
        loading={loading}
        error={error}
        onDelete={remove}
      />
    </div>
  );
};

export default PhotosView;
